import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FooterSection from '../../components/sections/FooterSection';

// --- Компоненты-заглушки для разделов админ-панели ---
var AllUsers = () => (
    <div>
        <h3>All Users</h3>
        <p>This section will display a comprehensive list of all registered users in a paginated table. You will be able to search, filter by role or status, and sort users. Each row will show key information like Username, Email, Role, and Last Login date. Actions will be available to view user details, edit, or suspend accounts.</p>
    </div>
);
var EditUsers = () => (
    <div>
        <h3>Edit User</h3>
        <p>Here, you will be able to modify the details of a specific user. This form will allow you to change their username, email, assigned roles, and password. You will also see an activity log for the selected user. This component will likely be loaded based on a user selected from the 'All Users' list.</p>
    </div>
);
var CreateUser = () => (
    <div>
        <h3>Create a New User</h3>
        <p>This form will allow you to manually create a new user account. You'll need to provide a username, a temporary password, an email address, and assign one or more roles to the user upon creation. An option to send a welcome email with login instructions will be included.</p>
    </div>
);
var EditArticles = () => (
    <div>
        <h3>Edit Articles (CMS)</h3>
        <p>Manage all content articles from here. This interface will provide a list of all articles with their title, author, status (Published, Draft, Archived), and last modified date. You will be able to create new articles, edit existing ones using a rich-text editor, and manage categories or tags.</p>
    </div>
);
var EditJobs = () => (
    <div>
        <h3>Edit Jobs</h3>
        <p>This section is for managing job postings. You will see a list of all open, closed, and draft job positions. From here, you can create a new job posting, edit details like the title, description, location, and salary, and view applications submitted for each role.</p>
    </div>
);
var EditRoles = () => (
    <div>
        <h3>Edit Roles</h3>
        <p>Manage user roles and their associated permissions. You can create new roles (e.g., 'Moderator', 'Content Editor') and delete existing ones. Selecting a role will allow you to assign or revoke specific permissions, which are managed in the 'Edit Attributes' section.</p>
    </div>
);
var EditAttributes = () => (
    <div>
        <h3>Edit Attributes (Permissions)</h3>
        <p>This area is for managing the fine-grained permissions, or 'attributes', that can be assigned to roles. You can define new attributes like 'can_edit_articles', 'can_delete_users', or 'can_access_ai_settings'. This provides a flexible and powerful way to control access across the admin panel.</p>
    </div>
);
var EditMapMarkings = () => (
    <div>
        <h3>Edit Map Markings</h3>
        <p>An interactive map interface will be displayed here, allowing you to manage geographical markers. You will be able to add new markers by clicking on the map, edit the title and description of existing markers, categorize them (e.g., 'Point of Interest', 'Office'), and remove them.</p>
    </div>
);
var EditJaiLocations = () => (
    <div>
        <h3>Edit Jai Locations</h3>
        <p>Manage the list of official 'Jai Locations'. This will be a table where you can add, edit, or remove locations. Each location will have fields for its name, full address, contact information, opening hours, and a short description of the services available there.</p>
    </div>
);
var EditAiBotSettings = () => (
    <div>
        <h3>Edit AI Bot Settings</h3>
        <p>Configure the behavior of the integrated AI Bot. This settings page will include fields for the bot's name, system prompt or personality, API keys for the language model service, and rules for its engagement. You might also manage knowledge base documents that the bot uses for its responses.</p>
    </div>
);

var componentMap = {
    'all-users': <AllUsers />,
    'edit-users': <EditUsers />,
    'create-user': <CreateUser />,
    'edit-articles': <EditArticles />,
    'edit-jobs': <EditJobs />,
    'edit-roles': <EditRoles />,
    'edit-attributes': <EditAttributes />,
    'edit-map-markings': <EditMapMarkings />,
    'edit-jai-locations': <EditJaiLocations />,
    'edit-ai-bot-settings': <EditAiBotSettings />,
};

function AdminPanelPage(props) {

    var { t } = useTranslation();
    var [activeComponentKey, setActiveComponentKey] = useState(null);

    var renderActiveComponent = () => {
        if (!activeComponentKey) {
            return <p>{t('Select an item from the menu to see its content here.')}</p>;
        }
        return componentMap[activeComponentKey] || <p>Component not found.</p>;
    };

    return (
        <>
            <div className="uk-container uk-container-small uk-margin-xlarge-bottom uk-margin-large-top">
                <h1>
                    Admin Panel
                </h1>
                <div className="uk-grid-divider" data-uk-grid>
                    <div className="uk-width-1-4@m">
                        {/* Левая колонка с меню-аккордеоном */}
                        <ul data-uk-accordion>
                            <li className="uk-open">
                                <a className="uk-accordion-title" href="#">{t('Users')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('all-users')}><a>{t('All users')}</a></li>
                                        <li onClick={() => setActiveComponentKey('edit-users')}><a>{t('Edit users')}</a></li>
                                        <li onClick={() => setActiveComponentKey('create-user')}><a>{t('Create a user')}</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a className="uk-accordion-title" href="#">{t('CMS')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('edit-articles')}><a>{t('Edit Articles')}</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a className="uk-accordion-title" href="#">{t('Jobs')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('edit-jobs')}><a>{t('Edit Jobs')}</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a className="uk-accordion-title" href="#">{t('Roles')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('edit-roles')}><a>{t('Edit Roles')}</a></li>
                                        <li onClick={() => setActiveComponentKey('edit-attributes')}><a>{t('Edit Attributes')}</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a className="uk-accordion-title" href="#">{t('Map')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('edit-map-markings')}><a>{t('Edit map markings')}</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a className="uk-accordion-title" href="#">{t('Locations')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('edit-jai-locations')}><a>{t('Edit Jai Locations')}</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a className="uk-accordion-title" href="#">{t('AI Bot')}</a>
                                <div className="uk-accordion-content">
                                    <ul className="uk-nav uk-nav-default">
                                        <li onClick={() => setActiveComponentKey('edit-ai-bot-settings')}><a>{t('Edit AI bot settings')}</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="uk-width-3-4@m">
                        {/* Правая колонка для отображения контента */}
                        <div className="uk-card uk-card-default uk-card-body">
                            {renderActiveComponent()}
                        </div>
                    </div>
                </div>
            </div>
            <FooterSection />
        </>
    );
}

export default AdminPanelPage;